var virtualPageView = function(page) {
    var query = win.store.state.query;
    var rmcnf = win.$url.decodeRmcnf(query.rmcnf);
    travellers = 0;
    for (var room = 0; room < rmcnf.length; room++) {
    	travellers += parseInt(rmcnf[room].adults) + parseInt(rmcnf[room].children);
    }
	win.dataLayer.push( {
		event: 'virtual-pageview',
		custompage: page,
		travellers: travellers,
		rooms: win.$url.decodeRmcnf(query.rmcnf).length,
		start: query.start,
		end: query.end,
		nonights: win.calendar.diffDays(win.calendar.parseDate(query.end), win.calendar.parseDate(query.start)),
		daystostay: win.calendar.diffDays(win.calendar.parseDate(win.store.state.today), win.calendar.parseDate(query.start))
	});
};